var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddModule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0995 5.52318C14.3535 5.05217 18.6466 5.05217 22.9007 5.52318C25.2561 5.78718 27.1563 7.64206 27.4327 10.0057C27.9368 14.3204 27.9368 18.6792 27.4327 22.9939C27.1563 25.3576 25.2561 27.2124 22.9007 27.4764C18.6466 27.9474 14.3535 27.9474 10.0995 27.4764C7.74408 27.2124 5.84383 25.3576 5.56745 22.9939C5.06345 18.6796 5.06345 14.3213 5.56745 10.0071C5.70725 8.85875 6.23072 7.79131 7.05305 6.97772C7.87537 6.16413 8.94835 5.65208 10.0981 5.52456M16.5001 9.63443C16.7736 9.63443 17.0359 9.74308 17.2293 9.93648C17.4227 10.1299 17.5313 10.3922 17.5313 10.6657V15.4686H22.3342C22.6077 15.4686 22.87 15.5772 23.0634 15.7706C23.2568 15.964 23.3655 16.2263 23.3655 16.4998C23.3655 16.7733 23.2568 17.0356 23.0634 17.229C22.87 17.4224 22.6077 17.5311 22.3342 17.5311H17.5313V22.3339C17.5313 22.6074 17.4227 22.8697 17.2293 23.0631C17.0359 23.2565 16.7736 23.3652 16.5001 23.3652C16.2266 23.3652 15.9643 23.2565 15.7709 23.0631C15.5775 22.8697 15.4688 22.6074 15.4688 22.3339V17.5311H10.666C10.3924 17.5311 10.1301 17.4224 9.93675 17.229C9.74335 17.0356 9.6347 16.7733 9.6347 16.4998C9.6347 16.2263 9.74335 15.964 9.93675 15.7706C10.1301 15.5772 10.3924 15.4686 10.666 15.4686H15.4688V10.6657C15.4688 10.3922 15.5775 10.1299 15.7709 9.93648C15.9643 9.74308 16.2266 9.63443 16.5001 9.63443Z",
    fill: "#FEC200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddModule);
export default __webpack_public_path__ + "static/media/addModule.76d4bab9461e59fba8f0fac1f60eba97.svg";
export { ForwardRef as ReactComponent };